/**
 * The Wild Turtle — filters.js
 * Collection page filtering with URL params and AJAX updates
 */

(() => {
  'use strict';

  const filterToggle  = document.getElementById('filter-drawer-toggle');
  const filterDrawer  = document.getElementById('filter-drawer');
  const filterClose   = document.getElementById('filter-drawer-close');
  const filterApply   = document.getElementById('filter-drawer-apply');
  const overlay       = document.getElementById('page-overlay');

  /* =========================================================
     Mobile Filter Drawer
  ========================================================= */
  function openFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.classList.add('is-open');
    filterDrawer.removeAttribute('aria-hidden');
    filterDrawer.removeAttribute('inert');
    filterToggle?.setAttribute('aria-expanded', 'true');
    overlay?.classList.add('is-visible');
    filterClose?.focus();
  }

  function closeFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.classList.remove('is-open');
    filterDrawer.setAttribute('aria-hidden', 'true');
    filterDrawer.setAttribute('inert', '');
    filterToggle?.setAttribute('aria-expanded', 'false');
    overlay?.classList.remove('is-visible');
    filterToggle?.focus();
  }

  filterToggle?.addEventListener('click', openFilterDrawer);
  filterClose?.addEventListener('click', closeFilterDrawer);
  overlay?.addEventListener('click', closeFilterDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeFilterDrawer(); });

  /* =========================================================
     Build filter URL from current checked inputs
  ========================================================= */
  function buildFilterURL(source = document) {
    const url    = new URL(window.location.href);
    const params = new URLSearchParams();

    // Preserve sort_by
    const sort = url.searchParams.get('sort_by');
    if (sort) params.set('sort_by', sort);

    source.querySelectorAll('[data-filter-input]').forEach(input => {
      if (input.type === 'checkbox' && input.checked && !input.disabled) {
        params.append(input.name, input.value);
      } else if (input.type === 'number' && input.value) {
        params.set(input.name, input.value);
      } else if (input.type === 'range') {
        if (input.hasAttribute('data-range-min') && +input.value > 0) {
          params.set(input.name, input.value);
        } else if (input.hasAttribute('data-range-max') && +input.value < +input.max) {
          params.set(input.name, input.value);
        }
      }
    });

    return `${url.pathname}?${params.toString()}`;
  }

  /* =========================================================
     Sidebar desktop — live filter on checkbox change
  ========================================================= */
  const sidebar = document.getElementById('collection-sidebar');
  if (sidebar) {
    sidebar.addEventListener('change', e => {
      const input = e.target.closest('[data-filter-input]');
      if (input && input.type === 'checkbox') {
        window.location = buildFilterURL(sidebar);
      }
    });

    // Price range apply button
    sidebar.querySelectorAll('[data-filter-apply]').forEach(btn => {
      btn.addEventListener('click', () => {
        window.location = buildFilterURL(sidebar);
      });
    });
  }

  /* =========================================================
     Mobile drawer — apply on button click
  ========================================================= */
  filterApply?.addEventListener('click', () => {
    window.location = buildFilterURL(filterDrawer);
    closeFilterDrawer();
  });

  /* =========================================================
     Filter group accordion toggle
  ========================================================= */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-filter-toggle]');
    if (!btn) return;
    const expanded = btn.getAttribute('aria-expanded') !== 'false';
    btn.setAttribute('aria-expanded', !expanded);
    const body = btn.nextElementSibling;
    if (body) body.style.display = expanded ? 'none' : '';
  });

  /* =========================================================
     Sort by dropdown
  ========================================================= */
  const sortSelect = document.getElementById('sort-by');
  if (sortSelect) {
    // Already handled by inline onchange — leave as is
  }

})();
